import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useLanguage } from '../../context/LanguageContext'

export default function ContentCarousel({
  items,
  renderSlide,
  className = '',
  dark = false,
}) {
  const { isRTL } = useLanguage()
  const [index, setIndex] = useState(0)
  const total = items.length

  if (!total) return null

  const prev = () => setIndex((i) => (i - 1 + total) % total)
  const next = () => setIndex((i) => (i + 1) % total)

  return (
    <div className={`relative ${className}`}>
      <div
        className={`overflow-hidden rounded-2xl border ${
          dark
            ? 'border-white/10 bg-primary text-white'
            : 'border-border/60 bg-background'
        }`}
      >
        {renderSlide(items[index], index)}
      </div>
      {total > 1 && (
        <div className="mt-4 flex items-center justify-between gap-4">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={prev}
              className={`rounded-full p-2 transition-colors ${
                dark ? 'bg-white/10 hover:bg-white/20' : 'bg-primary/5 hover:bg-primary/10'
              }`}
              aria-label="Previous"
            >
              <ChevronLeft className={`h-5 w-5 ${isRTL ? 'rotate-180' : ''}`} />
            </button>
            <button
              type="button"
              onClick={next}
              className={`rounded-full p-2 transition-colors ${
                dark ? 'bg-white/10 hover:bg-white/20' : 'bg-primary/5 hover:bg-primary/10'
              }`}
              aria-label="Next"
            >
              <ChevronRight className={`h-5 w-5 ${isRTL ? 'rotate-180' : ''}`} />
            </button>
          </div>
          <div className="flex gap-1.5">
            {items.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setIndex(i)}
                className="flex h-6 w-6 items-center justify-center"
                aria-label={`Slide ${i + 1}`}
                aria-current={i === index ? 'true' : undefined}
              >
                <span
                  className={`block rounded-full transition-all ${
                    i === index ? 'h-2 w-6 bg-accent' : 'h-2 w-2 bg-primary/20'
                  }`}
                />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export function CarouselLink({ to, children }) {
  return (
    <Link
      to={to}
      className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-accent hover:text-primary"
    >
      {children}
    </Link>
  )
}
